// ============================================================
//  src/permissions.js
//  Asset Tracker permission tiers, from the "Asset Tracker: Company
//  Permissions Table" (Labor Board and Asset Tracker Permissions Table.xlsx,
//  10/23 version). Role slugs are at_role values.
//
//  Full  access: add items, edit items, reassign items, Admin pages
//  User  access: scan QR codes, view items, My Items, start transfers
//  Basic access: scan QR codes, view items, My Items (no transfers)
//
//  The server (ngc-tracker-api config/access-tiers.js) enforces the same
//  lists; keep the two in step.
// ============================================================

export const FULL_ACCESS_ROLES  = ['power_user', 'general_superintendent'];
export const USER_ACCESS_ROLES  = ['accountant', 'driver', 'foreman', 'project_administrator',
                                   'project_engineer', 'project_manager',
                                   'safety_director', 'site_supervisor'];
export const BASIC_ACCESS_ROLES = ['carpenter', 'laborer', 'view_only'];

export const isFullAccess = (role) => FULL_ACCESS_ROLES.includes(role);
export const canTransferItems = (role) => FULL_ACCESS_ROLES.includes(role) || USER_ACCESS_ROLES.includes(role);
